var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalendar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "0CD60A47-3EB1-401B-B66E-D0030D15A012")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cadastro-da-Proposta",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cadastro_Ficha-Completa_preenchido",
    transform: "translate(-644.000000, -881.000000)",
    fill: "#E71037",
    fillRule: "nonzero",
    stroke: "#E71037",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(645.000000, 882.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.421875,1.5625 L15.625,1.5625 L15.625,0.625 C15.625,0.27984375 15.3451953,0 15,0 C14.6548047,0 14.375,0.27984375 14.375,0.625 L14.375,1.5625 L5.625,1.5625 L5.625,0.625 C5.625,0.27984375 5.34519531,0 5,0 C4.65480469,0 4.375,0.27984375 4.375,0.625 L4.375,1.5625 L2.578125,1.5625 C1.15652344,1.5625 0,2.71902344 0,4.140625 L0,17.421875 C0,18.8434766 1.15652344,20 2.578125,20 L17.421875,20 C18.8434766,20 20,18.8434766 20,17.421875 L20,4.140625 C20,2.71902344 18.8434766,1.5625 17.421875,1.5625 Z M2.578125,2.8125 L4.375,2.8125 L4.375,3.4375 C4.375,3.78265625 4.65480469,4.0625 5,4.0625 C5.34519531,4.0625 5.625,3.78265625 5.625,3.4375 L5.625,2.8125 L14.375,2.8125 L14.375,3.4375 C14.375,3.78265625 14.6548047,4.0625 15,4.0625 C15.3451953,4.0625 15.625,3.78265625 15.625,3.4375 L15.625,2.8125 L17.421875,2.8125 C18.1542188,2.8125 18.75,3.40828125 18.75,4.140625 L18.75,5.625 L1.25,5.625 L1.25,4.140625 C1.25,3.40828125 1.84578125,2.8125 2.578125,2.8125 Z M17.421875,18.75 L2.578125,18.75 C1.84578125,18.75 1.25,18.1542188 1.25,17.421875 L1.25,6.875 L18.75,6.875 L18.75,17.421875 C18.75,18.1542188 18.1542188,18.75 17.421875,18.75 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.fa26e075.svg";
export { ForwardRef as ReactComponent };